// Тегленията от пинпада по тази сметка (регистърът `card_payments`;
// docs/card-payments.md в BE репото).
//
// Блокът стои под хронологията, защото не е операция по сметката, а следа от
// терминала: същата сума може да е взета, върната и взета отново, без това да
// личи в timeline-а. „БЕЗ БОН" е единственото място в прозореца, което вика —
// пари са взети, а фискален документ няма.

import { useTranslation } from "react-i18next";

import type { BillCardPayment } from "../../../../api/bills";
import { fmtEuro } from "../../../../utils/currency";

type Props = {
  payments: BillCardPayment[];
  isNarrow: boolean;
};

export const BillOperationsCardPayments = ({ payments, isNarrow }: Props) => {
  const { t } = useTranslation();

  return (
    <section
      className={`flex shrink-0 flex-col gap-2 border-t border-shade-1 ${
        isNarrow ? "px-4 py-3" : "px-6 py-3.5"
      }`}
    >
      <p className="font-pos-mono text-[10.5px] font-bold uppercase leading-none tracking-[0.14em] text-muted">
        {t("reportsPage.billOpsCardSection")}
      </p>

      {payments.map((payment) => (
        <div
          key={payment.id}
          className="flex flex-wrap items-baseline gap-x-3 gap-y-1 text-[12px] leading-[1.4] text-soft"
        >
          <span className="font-pos-mono text-[13px] font-bold tabular-nums text-ink">
            {fmtEuro(payment.amount)}
          </span>
          {payment.masked_pan ? (
            <span className="font-pos-mono tabular-nums">
              {payment.masked_pan}
            </span>
          ) : null}
          {payment.rrn ? (
            <span>
              RRN{" "}
              <span className="font-pos-mono tabular-nums">{payment.rrn}</span>
            </span>
          ) : null}
          {payment.auth_id ? (
            <span>
              AC{" "}
              <span className="font-pos-mono tabular-nums">
                {payment.auth_id}
              </span>
            </span>
          ) : null}
          <CardStatus payment={payment} />
          {payment.refund_rrn ? (
            <span>
              {t("reportsPage.billOpsCardRefunded")}{" "}
              <span className="font-pos-mono tabular-nums">
                {payment.refund_rrn}
              </span>
            </span>
          ) : null}
        </div>
      ))}
    </section>
  );
};

const CardStatus = ({ payment }: { payment: BillCardPayment }) => {
  const { t } = useTranslation();

  if (payment.status === "consumed") {
    return (
      <span>
        {payment.receipt_number
          ? `${t("reportsPage.receiptNumber")} ${payment.receipt_number}`
          : t("reportsPage.billOpsCardWithReceipt")}
      </span>
    );
  }
  if (payment.status === "voided") {
    return <span>{t("reportsPage.billOpsCardVoided")}</span>;
  }
  // unknown / void_failed — парите са взети, бон няма. Единственият силен тон
  // в прозореца, защото повторното теглене струва пари на заведението.
  return (
    <span className="font-semibold text-brand-deep-ink">
      {t("reportsPage.billOpsCardNoReceipt")}
    </span>
  );
};
